// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Sudan from '../_raw/flag/icon_flag_sudan.png';

export default () => <img src={Sudan} alt="Sudan" />;
